/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import {Link, Switch, Redirect} from "react-router-dom";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import {ContentRoute} from "../../../../_metronic/layout"
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import "../../../../_metronic/_assets/sass/pages/login/login-3.scss";

export function AuthPage() {
  return (
      <>
        <div className="d-flex flex-column flex-root">
          {/*begin::Login*/}
          <div
              className="login login-3 h-100 login-signin-on no-gutters row bg-white"
              id="kt_login"
          >
            {/*begin::Aside*/}

            <div
                className="login-aside bgi-size-cover no-gutters bgi-no-repeat col-md-6 py-lg-10"
                style={{
                  backgroundImage: `url(${toAbsoluteUrl("/images/home-bg-new.png")})`
                }}
            >

              <div className={'h-100 d-flex align-items-center flex-column justify-content-center'}>

                <div style={{background: 'rgba(255,255,255,0.8)'}} className={'py-16 w-100'}>

                  <div className="text-center h1 font-weight-bolder text-dark text-center">PORTAIL DE GESTION DES TRAVAUX</div>

                  <div className="text-center mt-5">
                    <img src={'/images/logo_cie.jpg'} width={108} className={'d-inline-block mr-8'} />
                    <img src={'/images/sodeci-logo.png'} width={178} />
                  </div>

                </div>

              </div>

            </div>
            {/*begin::Aside*/}

            <div className="col-md-6 d-flex align-items-center col-12">

              <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden">
                {/*begin::Content header*/}
                {/*<div className="position-absolute top-0 right-0 text-right mt-5 mb-15 mb-lg-0 flex-column-auto justify-content-center py-5 px-10">*/}
                {/*  <span className="font-weight-bold text-dark-50">Don't have an account yet?</span>*/}
                {/*  <Link to="/auth/registration" className="font-weight-bold ml-2" id="kt_login_signup">Sign Up!</Link>*/}
                {/*</div>*/}
                {/*end::Content header*/}

                {/* begin::Content body */}
                <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
                  <Switch>
                    <ContentRoute path="/auth/login" component={Login}/>
                    <ContentRoute path="/auth/registration" component={Registration}/>
                    <ContentRoute
                        path="/auth/forgot-password"
                        component={ForgotPassword}
                    />
                    <Redirect from="/auth" exact={true} to="/auth/login"/>
                    <Redirect to="/auth/login"/>
                  </Switch>
                </div>
                {/*end::Content body*/}

                {/* begin::Mobile footer */}
                <div
                    className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
                  <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                    &copy; 2020 Metronic
                  </div>
                  <div className="d-flex order-1 order-sm-2 my-2">
                    <Link to="/terms" className="text-dark-75 text-hover-primary">
                      Privacy
                    </Link>
                    <Link
                        to="/terms"
                        className="text-dark-75 text-hover-primary ml-4"
                    >
                      Legal
                    </Link>
                    <Link
                        to="/terms"
                        className="text-dark-75 text-hover-primary ml-4"
                    >
                      Contact
                    </Link>
                  </div>
                </div>
                {/* end::Mobile footer */}
              </div>

            </div>
            {/*begin::Content*/}
            {/*end::Content*/}
          </div>
          {/*end::Login*/}
        </div>
      </>
  );
}
